import api from 'Application/api/api';

const getUsersWithSupervisorPermissions = (cancelToken = null) =>
    api.get('project-manager/supervisor-users', { cancelToken });

export default getUsersWithSupervisorPermissions;
